



























import SmallText from "@/common/components/atoms/SmallText.vue";
import IconInvestedRounded from "@/common/components/icons/IconInvestedRounded.vue";
import commons from "@/common/store/modules/commons";
import { Vue, Component, Prop } from "vue-property-decorator";

import { getThanksOrGrantTypeLabel } from "@/common/assets/js/utils/types.ts";
import { mapState } from "vuex";

@Component({
  components: {
    SmallText,
    IconInvestedRounded
  },
  filters: {
    addComma(value: any) {
      const number = Number(value);
      if (Number.isNaN(number)) {
        return value;
      }
      return number.toLocaleString();
    }
  },
  computed: {
    ...mapState({
      storeColorCode: () => commons.colorCode
    })
  }
})
export default class IConditionsListPanel extends Vue {
  @Prop(Object) conditionsDetail: any | unknown;
  unit = commons.unit;
  point = commons.OrgPageSpecific?.point_name;
  storeColorCode: string;

  get id() {
    return this.conditionsDetail.id;
  }

  get name() {
    return this.conditionsDetail.name;
  }
  get kindResult() {
    return getThanksOrGrantTypeLabel(this.conditionsDetail.kind);
  }

  get iconType() {
    return this.conditionsDetail.grant_criteria_icon_id;
  }

  get points() {
    return this.conditionsDetail.points;
  }

  get url() {
    return this.conditionsDetail.url;
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }

  get colorCode() {
    if(this.isGroupBudget) {
      return '#fc9014'
    }
    return this.storeColorCode
  }
}
